import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

// Use current origin for API calls to work on any deployed domain
const API = `${window.location.origin}/api`;

const OAuthCallback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Processing login...');
  const [error, setError] = useState(null);

  useEffect(() => {
    const processOAuth = async () => {
      // Get session_id from URL
      const fullUrl = window.location.href;
      const hash = window.location.hash;
      const search = window.location.search;
      
      console.log('🔍 OAuth Callback - Full URL:', fullUrl);
      console.log('🔍 API URL:', API);
      
      let sessionId = null;
      
      // Check all possible locations for session_id
      if (hash && hash.includes('session_id=')) {
        sessionId = hash.split('session_id=')[1].split('&')[0].split('#')[0];
        console.log('📍 Found session_id in hash:', sessionId);
      } else if (search && search.includes('session_id=')) {
        sessionId = search.split('session_id=')[1].split('&')[0].split('#')[0];
        console.log('📍 Found session_id in search:', sessionId);
      } else if (fullUrl.includes('session_id=')) {
        sessionId = fullUrl.split('session_id=')[1].split('&')[0].split('#')[0];
        console.log('📍 Found session_id in fullUrl:', sessionId);
      }
      
      if (!sessionId) {
        console.error('❌ No session_id found in URL');
        setError(`No session_id found. URL: ${fullUrl}`);
        setStatus('Login failed - no session found');
        setTimeout(() => navigate('/'), 3000);
        return;
      }
      
      console.log('🔐 Processing session:', sessionId);
      setStatus('Verifying your account...');
      
      try {
        console.log('📡 Calling:', `${API}/auth/session`);
        const response = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true,
            timeout: 15000
          }
        );
        
        console.log('✅ OAuth successful:', response.data.user?.email);
        
        // Store session token in localStorage as backup for mobile browsers
        if (response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
          console.log('💾 Session token stored in localStorage');
        }
        
        setStatus('Login successful! Redirecting...');
        
        // Force a full page reload to dashboard to ensure AuthContext picks up the session
        window.location.href = '/dashboard';
      } catch (err) {
        console.error('❌ OAuth failed:', err);
        const errorMsg = err.response?.data?.detail || err.message;
        setError(`API: ${API} | Session: ${sessionId.substring(0, 10)}... | Error: ${errorMsg}`);
        setStatus('Login failed. Please try again.');
        setTimeout(() => navigate('/'), 5000);
      }
    };
    
    processOAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center theme-bg p-4">
      <Loader2 className="w-12 h-12 animate-spin text-amber-600 mb-4" />
      <p className="text-amber-800 text-lg mb-2">{status}</p>
      {error && (
        <p className="text-red-600 text-xs text-center max-w-md mt-4 p-3 bg-red-50 rounded-lg break-all">
          {error}
        </p>
      )}
    </div>
  );
};

export default OAuthCallback;
